
import React from "react";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export const ChatLoadingState: React.FC = () => {
  return (
    <div className="min-h-screen bg-black flex flex-col lg:pl-64 pt-8">
      <div className="bg-black/90 backdrop-blur-lg border-b border-white/10 py-3 px-4 flex items-center fixed top-0 left-0 right-0 lg:left-64 z-10">
        <Link to="/main/chats" className="mr-3">
          <Button variant="ghost" size="icon" className="h-9 w-9 text-white/70">
            <ArrowLeft className="h-5 w-5" />
          </Button>
        </Link>
        
        <div className="flex items-center flex-1">
          <Skeleton className="h-9 w-9 rounded-full" />
          <div className="ml-3">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-3 w-16 mt-1" />
          </div>
        </div>
      </div>
      
      <div className="flex-1 overflow-y-auto p-4 pt-16 pb-24 space-y-3">
        {[...Array(5)].map((_, i) => (
          <div key={i} className={`flex ${i % 2 === 0 ? "justify-start" : "justify-end"}`}>
            <Skeleton className={`h-12 w-64 ${i % 2 === 0 ? "rounded-r-2xl rounded-tl-2xl" : "rounded-l-2xl rounded-tr-2xl"}`} />
          </div>
        ))}
      </div>
      
      <div className="bg-black border-t border-white/10 p-3 fixed bottom-0 left-0 right-0 lg:left-64 z-20">
        <div className="flex items-center space-x-2">
          <Skeleton className="h-10 w-10 rounded-full" />
          <Skeleton className="h-10 flex-1 rounded-full" />
          <Skeleton className="h-10 w-10 rounded-full" />
        </div>
      </div>
    </div>
  );
};
